import * as THREE from 'three';

import OBJLoader from 'three-obj-loader';
import MTLLoader from 'three-mtl-loader';

const mtlLoader = new MTLLoader(),
    pathModels = '/models/',
    models = {},
    promiseModel = name => models[name] = new Promise((resolve, reject) => {
        // THREE.OBJLoader weird trickery...
        const t = THREE;
        mtlLoader.load(`/${name}.mtl`, materials => {
            const objLoader = new t.OBJLoader();
            materials.preload();
            objLoader.setPath(pathModels);
            objLoader.setMaterials(materials);
            objLoader.load(`/${name}.obj`, resolve, undefined, reject);
        }, undefined, reject)
    });

mtlLoader.setPath(pathModels);
OBJLoader(THREE);

export const preloadModels = names => Promise.all(names.map(name => loadModel(name))),
    loadModel = name => models[name] || promiseModel(name);


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/Model.js